/* eslint-disable fp/no-loops */
/* eslint-disable fp/no-mutating-methods */
/* eslint-disable no-restricted-syntax */

import { TFunction } from 'i18next'

import { MatchingPairsQuestion } from '~/types/bootcamp'

import { BlockContent } from '~/bootcamp/Activities/types/activities.types'

import { AnswerType, MatchingPairsActivityData } from '../MatchingPairs.type'

import { sortedDataFormat } from './data.matchingPairs'

export interface IndividualMathOBJ {
  value: BlockContent[]
  key: string
  pairID: string
  /** The Sanity pair `_key`, when the source pair had one. */
  pairKey?: string
  isClicked?: boolean
  isCorrect?: boolean
  isWrong?: boolean
}

export function shuffleArray(
  array: sortedDataFormat[],
  difficultyLevel: number,
  totalrandom: boolean,
): Array<{ value: object; pairID: string; key: string; pairKey?: string }> {
  const firstArr = [...array].sort(() => Math.random() - 0.5).slice(0, difficultyLevel + 2)

  const newArr = firstArr.flatMap(({ element1, element2, key }, i) => [
    { value: element1, pairID: `element-${i + 1}`, key: `el1-${i + 1}`, pairKey: key },
    { value: element2, pairID: `element-${i + 1}`, key: `el2-${i + 1}`, pairKey: key },
  ])
  const shuffledArray = [...newArr].sort(() => Math.random() - 0.5)

  const element2Arr = shuffledArray.filter((item) => item.key.startsWith('el2-'))
  const element1Arr = shuffledArray.filter((item) => item.key.startsWith('el1-'))

  const remergedArray = element1Arr.flatMap((elem, index) => [elem, element2Arr[index]])

  return totalrandom ? shuffledArray : remergedArray
}

/** Sanity `_key` of each pair on screen, in `el1-` order; undefined if any pair lacks one. */
export function displayedPairKeys(items: Array<{ key: string; pairKey?: string }>): string[] | undefined {
  const keys = items.filter((item) => item.key.startsWith('el1-')).map((item) => item.pairKey)
  return keys.every((key): key is string => Boolean(key)) ? keys : undefined
}

export function generateMatchingPairsActivityData(
  questions: MatchingPairsQuestion[],
  history: number[],
): MatchingPairsActivityData {
  const questionIndex = questions.findIndex((_, i) => !history.includes(i))
  const question = questions[questionIndex]

  return { question, questionIndex }
}

export const getFeedBackString = (key: string | null, t: TFunction<'bootcamp', undefined>): string => {
  switch (key) {
    case AnswerType.SELECT_ALL_CORRECT:
      return t('feedback.select-all-correct')
    case AnswerType.SELECT_CORRECT:
      return t('feedback.select-correct')
    case AnswerType.SELECT_ONLY_CORRECT:
      return t('feedback.select-only-correct')
    default:
      return ''
  }
}
